import React from 'react';
import decodeHTMLEntities from '../../../utils/decode-html-entities';
import { PackageInfoPrice } from '../../package/PackageInfoPrice';

import TooltipInfoIcon from '../../TooltipInfoIcon';

export const PackageData = ({
    multiday,
    className,
    ticketPrice,
    packagePrice,
    isPackage,
    isSoldOut,
    isCanceled,
    canceledDate,
    isPremiereLocked,
    premiereDate,
    day,
    time,
    arena,
    city,
    special,
    alternatives,
}) => {
    return (
        <div className={className}>
            <div className="font-medium text-xs flex flex-col gap-y-1">
                <div className="font-bold text-base">
                    <PackageInfoPrice
                        ticketPrice={ticketPrice}
                        packagePrice={packagePrice}
                        isPackage={isPackage}
                        isSoldOut={isSoldOut}
                        isCanceled={isCanceled}
                        isPremiereLocked={isPremiereLocked}
                        premiereDate={premiereDate}
                    />
                </div>
                <div className="flex items-center gap-x-2">
                    <i className="icon-clock text-[16px]"></i>
                    <span>
                        {multiday ? alternatives : [day, time].filter(Boolean)
                            .join(' ')}

                        {special && special.discreet &&
                            <TooltipInfoIcon tooltip={special.information} />
                        }

                        {canceledDate && canceledDate.information &&
                            <TooltipInfoIcon tooltip={canceledDate.information} />
                        }
                    </span>
                </div>
                <div className="flex items-center gap-x-2">
                    <i className="icon-location text-[16px]"></i>
                    <span>
                        {arena != null ? [
                            decodeHTMLEntities(arena.title),
                            city,
                        ].join(', ') : city}
                    </span>
                </div>
            </div>
        </div>
    );
};
